import React, { useState } from "react";
import { TableCell, TableRow } from "@material-ui/core";
import { TrashIcon } from "App/Assets";
import { ModalDeleteConfirm, TableWrapper } from "App/Component/ui";
import IconButtonDatatable from "App/Component/ui/button/IconButtonDatatable";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { headCellsTF } from "./helpers";
import { useDatatables } from "App/hooks";
import { isNull } from "App/utils/helpers";

export default function ListTransfer({
  formData,
  listTF,
  setListTF,
}) {
  const [deleteID, setDeleteID] = useState([]);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: listTF,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  const handleClickDelete = (row) => {
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
    setDeleteID(row?.fixasset_id);
  };

  async function deleteList() {
    const barang = listTF;
    const checkBarang = barang.filter((e) => e.fixasset_id !== deleteID);
    setListTF(checkBarang);
    setShowModalDeleteConfirm(false);
  }

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <TableWrapper
        title="Daftar Transfer Asset Gudang Tujuan"
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={listTF}
        headCells={headCellsTF}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        withPadding={true}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {isNull(formData.id) ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "7px",
                      }}
                    >
                      <IconButtonDatatable
                        onClick={() => handleClickDelete(row)}
                      >
                        <TrashIcon />
                      </IconButtonDatatable>
                    </div>
                  ) : (
                    <></>
                  )}
                </TableCell>
                <TableCell align="left">{row?.fixasset_id}</TableCell>
                <TableCell align="left">{row?.name}</TableCell>
                <TableCell align="left">{row?.code}</TableCell>
                <TableCell align="left">{row?.merek}</TableCell>
                <TableCell align="left">{row?.type}</TableCell>
              </TableRow>
            );
          })}
      </TableWrapper>
    </>
  );
}
